import { c as _c } from "react/compiler-runtime";
import { BenefitTiles } from '@/components/tiles';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { SectionHeadline } from '@/components/SectionHeadline';
export function News() {
  const $ = _c(45);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["mallpay"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("news.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mx-auto max-w-192" anchorKey="news.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("news.items.1");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      title: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("news.items.2");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      title: t5
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("news.items.3");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      title: t7
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("news.items.4");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      title: t9
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("news.items.5");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      title: t11
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("news.items.6");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = {
      title: t13
    };
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t10 || $[30] !== t12 || $[31] !== t14 || $[32] !== t4 || $[33] !== t6 || $[34] !== t8) {
    t15 = <BenefitTiles background="bg-white" items={[t4, t6, t8, t10, t12, t14]} />;
    $[29] = t10;
    $[30] = t12;
    $[31] = t14;
    $[32] = t4;
    $[33] = t6;
    $[34] = t8;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = LINKS();
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const t17 = t16.registration;
  let t18;
  if ($[37] !== t) {
    t18 = t("news.cta");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18) {
    t19 = <Button to={t17} testId="mallpayRegistration" analyticsParam="mallpayRegistration" variant="primary" align="center" size="lg">{t18}</Button>;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t15 || $[42] !== t19 || $[43] !== t2) {
    t20 = <div className="flex flex-col gap-12 px-4 lg:gap-16">{t2}{t15}{t19}</div>;
    $[41] = t15;
    $[42] = t19;
    $[43] = t2;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  return t20;
}